<template>
  <div class="splash-screen">
    <div class="splash-content">
      <!-- Logo with animation -->
      <div class="logo-container">
        <img src="@/assets/cf-logo-mini.svg" alt="ChildFriendly" class="logo" />
      </div>

      <!-- Loading animation -->
      <div class="loading-container">
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
        <p class="loading-text">Loading...</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Simple splash component - controlled by App.vue
</script>

<style lang="sass" scoped>
.splash-screen
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  width: 100vw
  height: 100vh
  background: linear-gradient(135deg, #06b6d4 0%, #3b82f6 50%, #8b5cf6 100%)
  display: flex
  align-items: center
  justify-content: center
  z-index: 9999

.splash-content
  display: flex
  flex-direction: column
  align-items: center
  gap: 48px

.logo-container
  position: relative
  animation: logoFloat 2s ease-in-out infinite

  &::before
    content: ''
    position: absolute
    inset: -20px
    background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%)
    border-radius: 50%
    animation: logoGlow 2s ease-in-out infinite

.logo
  width: 140px
  height: 140px
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3))
  animation: logoPulse 2s ease-in-out infinite

.loading-container
  display: flex
  flex-direction: column
  align-items: center
  gap: 20px

.loading-dots
  display: flex
  gap: 14px

.dot
  width: 14px
  height: 14px
  background: white
  border-radius: 50%
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2)
  animation: dotBounce 1.4s infinite ease-in-out both

  &:nth-child(1)
    animation-delay: -0.32s

  &:nth-child(2)
    animation-delay: -0.16s

.loading-text
  color: white
  font-size: 18px
  font-weight: 600
  margin: 0
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3)
  letter-spacing: 0.5px
  animation: textFade 1.5s ease-in-out infinite

// Animations
@keyframes logoFloat
  0%, 100%
    transform: translateY(0)
  50%
    transform: translateY(-15px)

@keyframes logoPulse
  0%, 100%
    transform: scale(1)
  50%
    transform: scale(1.08)

@keyframes logoGlow
  0%, 100%
    opacity: 0.5
    transform: scale(1)
  50%
    opacity: 0.8
    transform: scale(1.1)

@keyframes dotBounce
  0%, 80%, 100%
    transform: scale(0) translateY(0)
    opacity: 0.4
  40%
    transform: scale(1.2) translateY(-10px)
    opacity: 1

@keyframes textFade
  0%, 100%
    opacity: 0.7
  50%
    opacity: 1

// Responsive
@media (max-width: 768px)
  .logo
    width: 110px
    height: 110px

  .loading-text
    font-size: 16px

  .dot
    width: 12px
    height: 12px
</style>
